import { render } from "./pozetron-web-shared-layout.vue?vue&type=template&id=5206e550"
import script from "./pozetron-web-shared-layout.vue?vue&type=script&lang=js"
export * from "./pozetron-web-shared-layout.vue?vue&type=script&lang=js"

import "./pozetron-web-shared-layout.vue?vue&type=style&index=0&id=5206e550&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__